import { render, staticRenderFns } from "./manageOrganizationView.vue?vue&type=template&id=57caa7bc&scoped=true&"
import script from "./manageOrganizationView.vue?vue&type=script&lang=ts&"
export * from "./manageOrganizationView.vue?vue&type=script&lang=ts&"
import style0 from "./manageOrganizationView.vue?vue&type=style&index=0&id=57caa7bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57caa7bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
